import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Facebook, Twitter, Youtube, Instagram, LinkedIn } from '../icon';
import { Typography } from '../typography/Typography';

// Interface
export interface ShareProps {
  type?: string;
  url?: string;
  shareText?: string;
  platforms?: string[];
}

// Styles
const StyledDiv = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.small};
  `};
`;

const StyledIconContainer = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${space.xxSmall};
  `};
`;

const platformComponents = {
  twitter: <Twitter />,
  facebook: <Facebook />,
  linkedIn: <LinkedIn />,
  instagram: <Instagram />,
  youTube: <Youtube />,
};

const platformUrls = {
  twitter: (url, text) => `https://twitter.com/share?url=${url}&text=${text}`,
  facebook: (url) => `https://www.facebook.com/sharer.php?u=${url}`,
  linkedIn: (url) =>
    `https://www.linkedin.com/shareArticle?mini=true&url=${url}`,
  instagram: (url) => `https://www.instagram.com/?url=${url}`,
  youTube: (url) => `https://www.youtube.com/?url=${url}`,
};

// JSX
export const Share: FC<ShareProps> = ({ type, url, shareText, platforms }) => (
  <StyledDiv>
    <Typography variant="bodyMediumBold" component="h3">
      Share this{type ? ` ${type}` : ''}:
    </Typography>

    <StyledIconContainer as="ul">
      {platforms?.map((platform) => (
        <li key={platform}>
          <a
            href={platformUrls[platform](url, shareText)}
            target="_blank"
            rel="noreferrer"
            title={platform || undefined}
          >
            {platformComponents[platform]}
          </a>
        </li>
      ))}
    </StyledIconContainer>
  </StyledDiv>
);

export default Share;
